const articles = [
    {
      id: 1,
      title: 'the WET Codbase',
      date: new Date(2022, 1, 4),
      length: 11,
      snippet: `Come waste your time with me`,
    },
    {
      id: 2,
      title: 'goodby, clean code',
      date: new Date(2022, 2, 22),
      length: 5,
      snippet: `Let clean code guide you. Then let it go.`,
    },
    {
      id: 3,
      title: 'my decade in review',
      date: new Date(2022, 3, 11),
      length: 5,
      snippet: `A personal reflection.`,
    },
    {
      id: 4,
      title: 'what are the react team principles',
      date: new Date(2022, 4, 4),
      length: 5,
      snippet: `UI Before API.`,
    },
  ]
  
  export default articles;